import $ from 'jquery';

$(function () {


    $('.background').each(function () {

        const step = 1;
        const $background = $(this);
        const $bgArea = $background.find('.background-bg');
        const waveTop = $background.hasClass('wave-top');
        const waveBottom = $background.hasClass('wave-bottom');

        // Init
        makeWave();


        function makeWave() {

            let pointCloud = [];
            if (waveTop) {
                for (let i = 0; i <= 100; i = i + step) {
                    const x = i;
                    const y = (Math.cos(i * 0.07) + 1) * 0.5;
                    const yString = `calc(var(--wave-amplitude) * ${y})`;
                    pointCloud.push(x + '% ' + yString);
                }
            } else {
                pointCloud.push('0 0');
                pointCloud.push('100% 0');
            }

            if (waveBottom) {
                for (let i = 100; i >= 0; i = i - step) {
                    const x = i;
                    const y = 1 - (Math.cos(i * 0.09) + 1) * 0.5;
                    const yString = `calc(100% - var(--wave-amplitude) * ${y})`;
                    pointCloud.push(x + '% ' + yString);
                }
            } else {
                pointCloud.push('100% 100%');
                pointCloud.push('0 100%');
            }

            const polygon = 'polygon(' + pointCloud.join(', ') + ')';

            $bgArea.css('clip-path', polygon);
        }

    });



});
